import Tour from './Tour';
export { tourProps } from './Tour';
export { tourStepInfo, tourStepProps } from './interface';
export default Tour;
